module.exports = "/_next/static/images/d231abbb4710e7e6255c8ffb90477cc0-cartao-proximo-ao-olho-xs@2x.jpg.webp";